import * as React from 'react';
import DayConfigurationSection from './DayConfigurationSection';
import Button from '../../../common/form/Button';
import { 
    PropertyConfiguration,
    DayConfiguration

} from '../../../../api/Property';
import { defaultDayConfiguration } from './EditPropertyPane';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import '../../../../styles/AdminPermissions.css'; 
import {userIsCompanyManageUser,userIsPropertyManageUser,userIsSystemManageUser} from '../../../../utilities/identity';

interface Props {
    propertyConfiguration: PropertyConfiguration;
    onChange: (
        dayName: string,
        dayFieldName: string,
        newValue: string,
        secondName?: string,
        secondValue?: string
    ) => void;
    onSubmit: (e: React.SyntheticEvent<HTMLFormElement>) => void;
    wasFormValidated: boolean;
    errorMessage?: string;
    isDisabled?: boolean;
}

const PropertyConfigurationTab = (props: Props) => {
    const days = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

    const isFormDisabled = (): boolean => {
        return (
            props.isDisabled || (userIsCompanyManageUser() ||  userIsPropertyManageUser() || userIsSystemManageUser()));
    };

    const renderDayRow = function(day: string, parentProps: Props) {
        let dayConfiguration: DayConfiguration | undefined =
            parentProps.propertyConfiguration[day.toLowerCase()];
        if (!dayConfiguration) {
            dayConfiguration = defaultDayConfiguration;
        }
        return (
            <DayConfigurationSection
                key={day}
                dayName={day}
                dayConfiguration={dayConfiguration}
                onChange={parentProps.onChange}
                isDisabled={isFormDisabled()}
            />
        );
    };

    return (
        <form
            noValidate={true}
            //className={`${props.wasFormValidated ? ' was-validated' : ''}`}
            className={`${props.wasFormValidated ? 'was-validated' : ''} property-configuration-form`}
            
            onSubmit={props.onSubmit}
        >
            <FormValidationDisplay errorMessage={props.errorMessage} />
            
            <div>{days.map(day => renderDayRow(day, props))}</div>
            <Button
                text="Update Property Configuration"
                addlClassName="btn-primary"
                type="submit"
                disabled={isFormDisabled()}
            />
        </form>
    );
};

export default PropertyConfigurationTab;


// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/PropertyConfigurationTab.tsx